import LocalStorageHelper from "./local-storage-helper";

const TIMESTAMP_OPTIONS = { timeZone: "America/Sao_Paulo", hour12: false };

const buildTimestamp = () =>
  new Date().toLocaleString("sv-SE", TIMESTAMP_OPTIONS).replace(" ", "T");

const getDeviceData = () => {
  const ua = navigator.userAgent;
  if (/Mobi|Android/i.test(ua)) return "mobile";
  if (/Tablet|iPad/i.test(ua)) return "tablet";
  return "desktop";
};

const getSectionFromUrl = () => {
  const path = window.location.pathname;

  const routePatterns = [
    { regex: /^\/previsao-do-tempo\/agora\/cidade/, section: "now" },
    { regex: /^\/previsao-do-tempo\/amanha\/cidade/, section: "tomorrow" },
    { regex: /^\/previsao-do-tempo\/fim-de-semana\/cidade/, section: "weekend" },
    { regex: /^\/previsao-do-tempo\/15-dias\/cidade/, section: "fifteen" },
    { regex: /^\/previsao-do-tempo\/cidade/, section: "today" },

    { regex: /^\/noticias/, section: "news" },
    { regex: /^\/destaques/, section: "news" },
    { regex: /^\/noticia/, section: "news" },
    { regex: /^\/graficos/, section: "charts" },
    { regex: /^\/climatologia/, section: "climatology" },
    { regex: /^\/satelite/, section: "satellite" },
    { regex: /^\/podcast/, section: "podcast" },
    { regex: /^\/podcasts/, section: "podcast" },
    { regex: /^\/uv/, section: "uv" },
    { regex: /^\/vento/, section: "wind" },
    { regex: /^\/previsao-por-email/, section: "email" },
    { regex: /^\/videos/, section: "videos" },
    { regex: /^\/clima-de-viagem/, section: "travel" },
    { regex: /^\/verao/, section: "summer" },
    { regex: /^\/inverno/, section: "winter" },
    { regex: /^\/$/, section: "home" },
    { regex: /^\/brasil/, section: "brazil" },
    { regex: /^\/beachInfo/, section: "beach" },
    { regex: /^\/previsao-do-tempo\/litoral/, section: "beach" },
    { regex: /^\/previsao-do-tempo\/aeroporto/, section: "airport" },
  ];

  for (const route of routePatterns) {
    if (route.regex.test(path)) {
      return route.section;
    }
  }

  return "home";
};

const mapLocationMeta = (locationData = null) => {
  if (!locationData) return {};

  let city = null;
  try {
    city = LocalStorageHelper.mapCityData(locationData);
  } catch (e) {
    city = null;
  }

  const hasCity = Boolean(locationData?.city);
  const hasAirport = Boolean(locationData?.airport);
  const type = hasCity ? "city" : hasAirport ? "airport" : "beach";

  const name =
    locationData?.city || locationData?.airport || locationData?.beach || "";
  const uf = locationData?.uf || locationData?.ac || "";
  const el_name = city?.label || (name && uf ? `${name} - ${uf}` : name);

  const el_id =
    city?.cloc ||
    locationData?.idlocale ||
    locationData?.idcity ||
    locationData?.idbeach ||
    locationData?.idairport ||
    null;

  return { city, type, el_id, el_name };
};

export const trackGeolocationResult = ({
  method = "page_view",
  status,
  locationData = null,
  coords = null,
} = {}) => {
  if (!status) return;

  try {
    const { city, type, el_id, el_name } = mapLocationMeta(locationData);

    const payload = {
      t: "update_geolocation",
      ts: buildTimestamp(),
      dc: getDeviceData(),
      sec: getSectionFromUrl(),
      url: window.location.href,
      method,
      status,
      type,
      el_id,
      el_name,
    };

    if (city) payload.city = city;

    if (coords?.latitude != null && coords?.longitude != null) {
      payload.coordinates = {
        latitude: coords.latitude,
        longitude: coords.longitude,
      };
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "update_geolocation",
      method,
      status,
      type,
      el_id,
      el_name,
    });

    if (status === "granted") {
      LocalStorageHelper.append("events_location", payload);
    }
  } catch (error) {
    console.error("Falha ao registrar update_geolocation:", error);
  }
};

export const trackGeolocationPopover = () => {
  try {
    const payload = {
      t: "interaction",
      ts: buildTimestamp(),
      dc: getDeviceData(),
      sec: getSectionFromUrl(),
      url: window.location.href,
      element: { id: "Popover_LocationPermission" },
    };

    LocalStorageHelper.append("events_interaction", payload);
  } catch (error) {
    console.error("Falha ao registrar interação de geolocalização:", error);
  }
};
